<template>
    <div>
    <!-- Панель инструментов -->
    <div v-if="editor" class="toolbar">
      <button @click="editor.chain().focus().toggleBold().run()" :class="{ active: editor.isActive('bold') }">
        <b>B</b>
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="{ active: editor.isActive('italic') }">
        <i>I</i>
      </button>
      <button @click="editor.chain().focus().toggleBulletList().run()" :class="{ active: editor.isActive('bulletList') }">
        <i class="bi bi-list-ul"></i>
      </button>
      <button @click="editor.chain().focus().toggleOrderedList().run()" :class="{ active: editor.isActive('orderedList') }">
        <i class="bi bi-list-ol"></i>
      </button>
      <button
          @click="editor.chain().focus().undo().run()"
          :disabled="!editor.can().chain().focus().undo().run()"
        >
          <i class="bi bi-arrow-counterclockwise"></i>
        </button>
        <button
          @click="editor.chain().focus().redo().run()"
          :disabled="!editor.can().chain().focus().redo().run()"
        >
          <i class="bi bi-arrow-clockwise"></i>
        </button>
    </div>

    <!-- Сам редактор -->
    <editor-content :editor="editor" class="editor-container" />
  </div>
</template>

<script>
import { useEditor, EditorContent } from '@tiptap/vue-3'
import StarterKit from '@tiptap/starter-kit'
import {watch, onBeforeUnmount, nextTick} from 'vue'

export default {
  name: 'PdfRiskComment',
  components: {EditorContent},
  props: {
    comment: {type: Object, default: () => ({})},
  },
  emits: ['update:comment'],
  setup(props, { emit }) {
    const editor = useEditor({
      content: props.comment?.text || '<p></p>',
      extensions: [StarterKit],
      onUpdate: ({ editor }) => {
        emit('update:comment', {
          ...props.comment,
          text: editor.getHTML(),
        })
      },
    })

    // Следим ЗА ВСЕМ объектом comment, а не только за .text
    watch(
      () => props.comment,
      async (newComment) => {
        if (!editor.value) return
        const newText = newComment?.text || '<p></p>'
        // сравниваем с текущим HTML, чтобы не затирать ввод
        if (newText !== editor.value.getHTML()) {
          // даём редактору "доготовиться", если он только что создан
          await nextTick()
          editor.value.commands.setContent(newText, { emitUpdate: false })
        }
      },
      { deep: false } // объект меняется целиком — deep не нужен
    )

    onBeforeUnmount(() => {
      editor.value?.destroy()
    })

    return { editor }
  },
}
</script>

<style scoped>
.toolbar {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 8px 8px 0 0;
  background-color: #f9f9f9;
}

.toolbar button {
  padding: 6px 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
}

.toolbar button.active {
  background-color: #4a90e2;
  color: white;
  border-color: #4a90e2;
}

/* Стили для редактора */
.editor-container {
  border: 1px solid #ddd;
  border-radius: 0 0 8px 8px;
  padding: 12px;
  min-height: 200px;
  width: 330px;
}

.editor-container :deep(.ProseMirror) {
  outline: none;
  min-height: 150px;
}
</style>